// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WhyHostFormBlock7-commonHeaderAdmin-_RHG1 {
	position: fixed !important;
}

.WhyHostFormBlock7-adminLayout-hAuZA {
	padding-top: 64px !important;
}

.WhyHostFormBlock7-box-rahOZ h2 {
	font-size: 21px;
	font-weight: 600;
}

.WhyHostFormBlock7-exportLink-Q7opX {
	margin-bottom: -29px;
}

.WhyHostFormBlock7-blockCenter-oNuHQ {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.WhyHostFormBlock7-panelHeader-lHWZh {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.WhyHostFormBlock7-currencyselect-HzVCV {
	width: 100%;
	margin-right: 0px;
}

.WhyHostFormBlock7-panelHeader-lHWZh {
	overflow: hidden;
	position: relative;
}

.WhyHostFormBlock7-mar0-x3D4J {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.WhyHostFormBlock7-blockCenter-oNuHQ {
		padding: 0px;
	}

	.WhyHostFormBlock7-panelHeader-lHWZh {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.WhyHostFormBlock7-sideAdminPageWrapper-ymjkb {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.WhyHostFormBlock7-panelHeader-lHWZh {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.WhyHostFormBlock7-table-MSBNB {
	display: table;
}

.WhyHostFormBlock7-tableRow-P5VBp {
	display: table-row;
}

.WhyHostFormBlock7-tableCell-0ajZO {
	display: table-cell;
	float: none;
}

.WhyHostFormBlock7-formGroup-HK3LU {
	margin-bottom: 6px;
}

.WhyHostFormBlock7-select-SnkFI {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.WhyHostFormBlock7-noMargin-RIHas {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.WhyHostFormBlock7-exportLink-Q7opX {
	padding-top: 10px;
	padding-right: 10px;
}

.WhyHostFormBlock7-labelTextNew-WsnBN {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.WhyHostFormBlock7-displayInline-c62Ze {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.WhyHostFormBlock7-btnUPdate-E7O7b {
	display: inline-block;
}

.WhyHostFormBlock7-btnModalDelete-RKcYo {
	display: inline-block;
	margin-left: 15px;
}

.WhyHostFormBlock7-radioBtn-USk8Y {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.WhyHostFormBlock7-backgroundImg-KamLn {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.WhyHostFormBlock7-btnUPdate-E7O7b {
		display: block;
		margin-bottom: 12px;
	}

	.WhyHostFormBlock7-btnModalDelete-RKcYo {
		display: block;
		margin-left: 0px;
	}

	.WhyHostFormBlock7-btnWidth-UwZTM {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.WhyHostFormBlock7-bannerImageBg-QW1J0 {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.WhyHostFormBlock7-bannerDelete-NOImL {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.WhyHostFormBlock7-modalRoot-qLkZF {
	padding: 32px;
}

.WhyHostFormBlock7-modalBorderBottom-SDJ8C {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.WhyHostFormBlock7-logInModalBody-FRZR8 {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.WhyHostFormBlock7-exportSection-CRTR_ {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.WhyHostFormBlock7-exportSectionGridSub-a59hj {
	grid-template-columns: 50% 49% !important;
}

.WhyHostFormBlock7-exportText-TVkIq {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.WhyHostFormBlock7-exportLinkImg-nQXfE {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.WhyHostFormBlock7-vtrMiddle-SpGh8 {
	vertical-align: middle;
}

.WhyHostFormBlock7-exportImg-EvERP {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.WhyHostFormBlock7-profileViewlabel-JseZW {
	display: inline-block;
	width: 38%
}

.WhyHostFormBlock7-profileViewMainContent-wCb2A {
	display: inline-block;
	width: 62%;
}

.WhyHostFormBlock7-profileViewMain-SV0Lt {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.WhyHostFormBlock7-profileViewInner-eaRrk {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.WhyHostFormBlock7-profileImageSection-BOuxY {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.WhyHostFormBlock7-lastviewInner-r3pPl {
	padding: 10px;
}

.WhyHostFormBlock7-whyHostHoriLine-OIToT {
	margin: 30px 0;
}

.WhyHostFormBlock7-tableGrid-IR1G3 {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.WhyHostFormBlock7-headingContent-RcKcL {
	font-size: 18px;
	font-weight: 500;
}

.WhyHostFormBlock7-refundTextColor-AjRtO {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.WhyHostFormBlock7-dividerLine-zftoR {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.WhyHostFormBlock7-smallContent-h_k9c {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.WhyHostFormBlock7-sideAdminPageWrapper-ymjkb {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.WhyHostFormBlock7-sideAdminPageWrapper-ymjkb {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.WhyHostFormBlock7-exportSection-CRTR_ {
		grid-template-columns: 100%;
	}

	.WhyHostFormBlock7-exportSectionGridSub-a59hj {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.WhyHostFormBlock7-profileViewlabel-JseZW {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.WhyHostFormBlock7-profileViewMainContent-wCb2A {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.WhyHostFormBlock7-ChangeToUpperCase-tbQoF {
	text-transform: uppercase
}

.WhyHostFormBlock7-noBorder-ALo5g {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.WhyHostFormBlock7-siteAdminHeading-xw1Ad {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.WhyHostFormBlock7-siteAdminSubHeading-Wd7nv {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.WhyHostFormBlock7-adminFormDivider-OEJVU {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}

.WhyHostFormBlock7-errorMessage-Gybql {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}

.WhyHostFormBlock7-panelHeader-lHWZh {
  border-radius: 0;
  width: 100%;
  display: block;
  font-size: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--primary-border);
}

.WhyHostFormBlock7-formGroup-HK3LU {
  margin-bottom: 6px;
}

.WhyHostFormBlock7-select-SnkFI {
  position: relative;
  display: inline-block;
  vertical-align: bottom;
  margin-right: 5px;
}

.WhyHostFormBlock7-labelText-Qj9bS {
  font-size: 14px;
  color: var(--secondary-foreground);
  margin: 6px 0px;
  line-height: 1.43;
  font-weight: normal;
  vertical-align: middle;
}

.WhyHostFormBlock7-space1-bpIYc {
	margin-bottom: 6px !important;
}

.WhyHostFormBlock7-space2-mQuZc {
	margin-bottom: 12px !important;
}

.WhyHostFormBlock7-space3-aXZmM {
	margin-bottom: 18px !important;
}

.WhyHostFormBlock7-space4-REmd1 {
	margin-bottom: 24px !important;
}

.WhyHostFormBlock7-space5-fYuGo {
	margin-bottom: 30px !important;
}

.WhyHostFormBlock7-space6-HfLDQ {
	margin-bottom: 36px !important;
}

.WhyHostFormBlock7-space7-tld85 {
	margin-bottom: 42px !important;
}

.WhyHostFormBlock7-spaceTop8-b8yUr {
	margin-bottom: 48px !important;
}

.WhyHostFormBlock7-spaceTop1-u5mjt {
	margin-top: 6px !important;
}

.WhyHostFormBlock7-spaceTop2-oz9_C {
	margin-top: 12px !important;
}

.WhyHostFormBlock7-spaceTop3-WFdH7 {
	margin-top: 18px !important;
}

.WhyHostFormBlock7-spaceTop4-qvlxQ {
	margin-top: 24px !important;
}

.WhyHostFormBlock7-spaceTop5-QE5S4 {
	margin-top: 30px !important;
}

.WhyHostFormBlock7-spaceTop6-NmoQE {
	margin-top: 36px !important;
}

.WhyHostFormBlock7-spaceTop7-cAVTz {
	margin-top: 42px !important;
}

.WhyHostFormBlock7-spaceTop8-b8yUr {
	margin-top: 48px !important;
}

.WhyHostFormBlock7-noMargin-RIHas {
	margin: 0px !important;
}

.WhyHostFormBlock7-padding1-N4L1W {
	padding-bottom: 6px !important;
}

.WhyHostFormBlock7-padding2-TICws {
	padding-bottom: 12px !important;
}

.WhyHostFormBlock7-padding3-izEYE {
	padding-bottom: 18px !important;
}

.WhyHostFormBlock7-padding4-e26n5 {
	padding-bottom: 24px !important;
}

.WhyHostFormBlock7-padding5-buck8 {
	padding-bottom: 30px !important;
}

.WhyHostFormBlock7-padding6-H5t8n {
	padding-bottom: 36px !important;
}

.WhyHostFormBlock7-padding7-j6t11 {
	padding-bottom: 42px !important;
}

.WhyHostFormBlock7-paddingTop1-lpx1B {
	padding-top: 6px !important;
}

.WhyHostFormBlock7-paddingTop2-pH_f2 {
	padding-top: 12px !important;
}

.WhyHostFormBlock7-paddingTop3-BO7zn {
	padding-top: 18px !important;
}

.WhyHostFormBlock7-paddingTop4-EZLev {
	padding-top: 24px !important;
}

.WhyHostFormBlock7-paddingTop5-d9eok {
	padding-top: 30px !important;
}

.WhyHostFormBlock7-paddingTop6-vLkcL {
	padding-top: 36px !important;
}

.WhyHostFormBlock7-paddingTop7-O80w_ {
	padding-top: 42px !important;
}

.WhyHostFormBlock7-noPadding-Fu1fL {
	padding: 0px !important;
}

.WhyHostFormBlock7-textBold-pEwzF {
	font-weight: 500 !important;
}

.WhyHostFormBlock7-textBolder-lyB_6 {
	font-weight: 700 !important;
}

.WhyHostFormBlock7-textNormal-GHdqu {
	font-weight: normal !important;
}

.WhyHostFormBlock7-spaceBottom20-y1BRF {
	margin-bottom: 20px;
}

.WhyHostFormBlock7-spaceBottom10-BAxnA {
	margin-bottom: 10px;
}

.WhyHostFormBlock7-marginNone-ybXnl {
	margin: 0;
}

.WhyHostFormBlock7-spaceBottom15-wIcq1 {
	margin-bottom: 15px;
}

.WhyHostFormBlock7-marginTopNone-iHl5a {
	margin-top: 0;
}

.WhyHostFormBlock7-spaceTop11-g4Eil {
	margin-top: 11px;
}

.WhyHostFormBlock7-spaceTop21-Rn7WN {
	margin-top: 21px;
}

.WhyHostFormBlock7-spaceTop20-v6mM_ {
	margin-top: 20px;
}

.WhyHostFormBlock7-spaceTop10-FJxjW {
	margin-top: 10px;
}

/*New Design Text Colors */

.WhyHostFormBlock7-textDarkBlue-Ysm_i {
	color: rgb(20, 39, 94) !important;
}

.WhyHostFormBlock7-textLightBlue-b27K4 {
	color: rgb(57, 87, 106) !important;
}

.WhyHostFormBlock7-textLightSandleGreen-OKgaX {
	color: rgb(76, 86, 41) !important;
}

.WhyHostFormBlock7-textLightBrown-dEloa {
	color: rgb(115, 79, 33) !important;
}

.WhyHostFormBlock7-textMediumMaroon-wvCH1 {
	color: rgb(87, 37, 51) !important;
}

.WhyHostFormBlock7-textBrown-mU44d {
	color: rgb(160, 47, 24) !important;
}

.WhyHostFormBlock7-textMaroon-ov8zD {
	color: rgb(155, 49, 67) !important;
}

.WhyHostFormBlock7-textDarkBrown-cWWN6 {
	color: rgb(83, 18, 16) !important;
}

.WhyHostFormBlock7-textMediumBrown-YbvH3 {
	color: rgb(142, 28, 10) !important;
}

.WhyHostFormBlock7-textSkyBlue-KdFvr {
	color: rgb(37, 117, 141) !important;
}

.WhyHostFormBlock7-textGray-thhvE {
	color: rgb(77, 65, 51) !important;
}

.WhyHostFormBlock7-btnWidth-UwZTM {
    width: 100%;
}

.WhyHostFormBlock7-displayFlex-KSOqi {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-column-gap: 15px;
       -moz-column-gap: 15px;
            column-gap: 15px;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
}

@media screen and (max-width: 991px) {
    .WhyHostFormBlock7-displayFlex-KSOqi {
        row-gap: 15px;
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-form.css","webpack://./src/components/helpers.css","webpack://./src/components/siteadmin/WhyHostPageSettings/WhyHostFormBlock7/WhyHostFormBlock7.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;;ACvUA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;ACJA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AC7BA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;ACxNA;IACI,WAAW;AACf;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAgB;OAAhB,qBAAgB;YAAhB,gBAAgB;IAChB,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;AAClC;;AAEA;IACI;QACI,aAAa;QACb,mBAAe;YAAf,eAAe;IACnB;AACJ","sourcesContent":[".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}",".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}","@import '../utils.css';\n\n.panelHeader {\n  border-radius: 0;\n  width: 100%;\n  display: block;\n  font-size: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--primary-border);\n}\n\n.formGroup {\n  margin-bottom: 6px;\n}\n\n.select {\n  position: relative;\n  display: inline-block;\n  vertical-align: bottom;\n  margin-right: 5px;\n}\n\n.labelText {\n  font-size: 14px;\n  color: var(--secondary-foreground);\n  margin: 6px 0px;\n  line-height: 1.43;\n  font-weight: normal;\n  vertical-align: middle;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../admin-common.css';\n@import '../../admin-form.css';\n@import '../../../helpers.css';\n\n.btnWidth {\n    width: 100%;\n}\n\n.displayFlex {\n    display: flex;\n    column-gap: 15px;\n    justify-content: space-between;\n}\n\n@media screen and (max-width: 991px) {\n    .displayFlex {\n        row-gap: 15px;\n        flex-wrap: wrap;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonHeaderAdmin": `WhyHostFormBlock7-commonHeaderAdmin-_RHG1`,
	"adminLayout": `WhyHostFormBlock7-adminLayout-hAuZA`,
	"box": `WhyHostFormBlock7-box-rahOZ`,
	"exportLink": `WhyHostFormBlock7-exportLink-Q7opX`,
	"blockCenter": `WhyHostFormBlock7-blockCenter-oNuHQ`,
	"panelHeader": `WhyHostFormBlock7-panelHeader-lHWZh`,
	"currencyselect": `WhyHostFormBlock7-currencyselect-HzVCV`,
	"mar0": `WhyHostFormBlock7-mar0-x3D4J`,
	"sideAdminPageWrapper": `WhyHostFormBlock7-sideAdminPageWrapper-ymjkb`,
	"table": `WhyHostFormBlock7-table-MSBNB`,
	"tableRow": `WhyHostFormBlock7-tableRow-P5VBp`,
	"tableCell": `WhyHostFormBlock7-tableCell-0ajZO`,
	"formGroup": `WhyHostFormBlock7-formGroup-HK3LU`,
	"select": `WhyHostFormBlock7-select-SnkFI`,
	"noMargin": `WhyHostFormBlock7-noMargin-RIHas`,
	"labelTextNew": `WhyHostFormBlock7-labelTextNew-WsnBN`,
	"displayInline": `WhyHostFormBlock7-displayInline-c62Ze`,
	"btnUPdate": `WhyHostFormBlock7-btnUPdate-E7O7b`,
	"btnModalDelete": `WhyHostFormBlock7-btnModalDelete-RKcYo`,
	"radioBtn": `WhyHostFormBlock7-radioBtn-USk8Y`,
	"backgroundImg": `WhyHostFormBlock7-backgroundImg-KamLn`,
	"btnWidth": `WhyHostFormBlock7-btnWidth-UwZTM`,
	"bannerImageBg": `WhyHostFormBlock7-bannerImageBg-QW1J0`,
	"bannerDelete": `WhyHostFormBlock7-bannerDelete-NOImL`,
	"modalRoot": `WhyHostFormBlock7-modalRoot-qLkZF`,
	"modalBorderBottom": `WhyHostFormBlock7-modalBorderBottom-SDJ8C`,
	"logInModalBody": `WhyHostFormBlock7-logInModalBody-FRZR8`,
	"exportSection": `WhyHostFormBlock7-exportSection-CRTR_`,
	"exportSectionGridSub": `WhyHostFormBlock7-exportSectionGridSub-a59hj`,
	"exportText": `WhyHostFormBlock7-exportText-TVkIq`,
	"exportLinkImg": `WhyHostFormBlock7-exportLinkImg-nQXfE`,
	"vtrMiddle": `WhyHostFormBlock7-vtrMiddle-SpGh8`,
	"exportImg": `WhyHostFormBlock7-exportImg-EvERP`,
	"profileViewlabel": `WhyHostFormBlock7-profileViewlabel-JseZW`,
	"profileViewMainContent": `WhyHostFormBlock7-profileViewMainContent-wCb2A`,
	"profileViewMain": `WhyHostFormBlock7-profileViewMain-SV0Lt`,
	"profileViewInner": `WhyHostFormBlock7-profileViewInner-eaRrk`,
	"profileImageSection": `WhyHostFormBlock7-profileImageSection-BOuxY`,
	"lastviewInner": `WhyHostFormBlock7-lastviewInner-r3pPl`,
	"whyHostHoriLine": `WhyHostFormBlock7-whyHostHoriLine-OIToT`,
	"tableGrid": `WhyHostFormBlock7-tableGrid-IR1G3`,
	"headingContent": `WhyHostFormBlock7-headingContent-RcKcL`,
	"refundTextColor": `WhyHostFormBlock7-refundTextColor-AjRtO`,
	"dividerLine": `WhyHostFormBlock7-dividerLine-zftoR`,
	"smallContent": `WhyHostFormBlock7-smallContent-h_k9c`,
	"ChangeToUpperCase": `WhyHostFormBlock7-ChangeToUpperCase-tbQoF`,
	"noBorder": `WhyHostFormBlock7-noBorder-ALo5g`,
	"siteAdminHeading": `WhyHostFormBlock7-siteAdminHeading-xw1Ad`,
	"siteAdminSubHeading": `WhyHostFormBlock7-siteAdminSubHeading-Wd7nv`,
	"adminFormDivider": `WhyHostFormBlock7-adminFormDivider-OEJVU`,
	"errorMessage": `WhyHostFormBlock7-errorMessage-Gybql`,
	"labelText": `WhyHostFormBlock7-labelText-Qj9bS`,
	"space1": `WhyHostFormBlock7-space1-bpIYc`,
	"space2": `WhyHostFormBlock7-space2-mQuZc`,
	"space3": `WhyHostFormBlock7-space3-aXZmM`,
	"space4": `WhyHostFormBlock7-space4-REmd1`,
	"space5": `WhyHostFormBlock7-space5-fYuGo`,
	"space6": `WhyHostFormBlock7-space6-HfLDQ`,
	"space7": `WhyHostFormBlock7-space7-tld85`,
	"spaceTop8": `WhyHostFormBlock7-spaceTop8-b8yUr`,
	"spaceTop1": `WhyHostFormBlock7-spaceTop1-u5mjt`,
	"spaceTop2": `WhyHostFormBlock7-spaceTop2-oz9_C`,
	"spaceTop3": `WhyHostFormBlock7-spaceTop3-WFdH7`,
	"spaceTop4": `WhyHostFormBlock7-spaceTop4-qvlxQ`,
	"spaceTop5": `WhyHostFormBlock7-spaceTop5-QE5S4`,
	"spaceTop6": `WhyHostFormBlock7-spaceTop6-NmoQE`,
	"spaceTop7": `WhyHostFormBlock7-spaceTop7-cAVTz`,
	"padding1": `WhyHostFormBlock7-padding1-N4L1W`,
	"padding2": `WhyHostFormBlock7-padding2-TICws`,
	"padding3": `WhyHostFormBlock7-padding3-izEYE`,
	"padding4": `WhyHostFormBlock7-padding4-e26n5`,
	"padding5": `WhyHostFormBlock7-padding5-buck8`,
	"padding6": `WhyHostFormBlock7-padding6-H5t8n`,
	"padding7": `WhyHostFormBlock7-padding7-j6t11`,
	"paddingTop1": `WhyHostFormBlock7-paddingTop1-lpx1B`,
	"paddingTop2": `WhyHostFormBlock7-paddingTop2-pH_f2`,
	"paddingTop3": `WhyHostFormBlock7-paddingTop3-BO7zn`,
	"paddingTop4": `WhyHostFormBlock7-paddingTop4-EZLev`,
	"paddingTop5": `WhyHostFormBlock7-paddingTop5-d9eok`,
	"paddingTop6": `WhyHostFormBlock7-paddingTop6-vLkcL`,
	"paddingTop7": `WhyHostFormBlock7-paddingTop7-O80w_`,
	"noPadding": `WhyHostFormBlock7-noPadding-Fu1fL`,
	"textBold": `WhyHostFormBlock7-textBold-pEwzF`,
	"textBolder": `WhyHostFormBlock7-textBolder-lyB_6`,
	"textNormal": `WhyHostFormBlock7-textNormal-GHdqu`,
	"spaceBottom20": `WhyHostFormBlock7-spaceBottom20-y1BRF`,
	"spaceBottom10": `WhyHostFormBlock7-spaceBottom10-BAxnA`,
	"marginNone": `WhyHostFormBlock7-marginNone-ybXnl`,
	"spaceBottom15": `WhyHostFormBlock7-spaceBottom15-wIcq1`,
	"marginTopNone": `WhyHostFormBlock7-marginTopNone-iHl5a`,
	"spaceTop11": `WhyHostFormBlock7-spaceTop11-g4Eil`,
	"spaceTop21": `WhyHostFormBlock7-spaceTop21-Rn7WN`,
	"spaceTop20": `WhyHostFormBlock7-spaceTop20-v6mM_`,
	"spaceTop10": `WhyHostFormBlock7-spaceTop10-FJxjW`,
	"textDarkBlue": `WhyHostFormBlock7-textDarkBlue-Ysm_i`,
	"textLightBlue": `WhyHostFormBlock7-textLightBlue-b27K4`,
	"textLightSandleGreen": `WhyHostFormBlock7-textLightSandleGreen-OKgaX`,
	"textLightBrown": `WhyHostFormBlock7-textLightBrown-dEloa`,
	"textMediumMaroon": `WhyHostFormBlock7-textMediumMaroon-wvCH1`,
	"textBrown": `WhyHostFormBlock7-textBrown-mU44d`,
	"textMaroon": `WhyHostFormBlock7-textMaroon-ov8zD`,
	"textDarkBrown": `WhyHostFormBlock7-textDarkBrown-cWWN6`,
	"textMediumBrown": `WhyHostFormBlock7-textMediumBrown-YbvH3`,
	"textSkyBlue": `WhyHostFormBlock7-textSkyBlue-KdFvr`,
	"textGray": `WhyHostFormBlock7-textGray-thhvE`,
	"displayFlex": `WhyHostFormBlock7-displayFlex-KSOqi`
};
module.exports = ___CSS_LOADER_EXPORT___;
